import axiosInstance from "./axiosInstance";

export async function fetchAllUsers(id) {
  try {
    const res = await axiosInstance.get("/users");
    return res.data;
  } catch (error) {
    throw error;
  }
}

export const getAllHR = async (params = {}) => {
  try {
    const res = await axiosInstance.get("/gethr", { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getHRbyID = async (id) => {
  try {
    const res = await axiosInstance.get(`/gethr/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const approveRejectHR = async (id, approvedStatus) => {
  try {
    const res = await axiosInstance.patch(`/update-hr-approval/${id}`, {
      approved: approvedStatus
    });
    return res.data.data.instructor;
  } catch (error) {
    throw error;
  }
};

export const updateJobStatus = async (payload) => {
  try {
    const res = await axiosInstance.post("/job-status/update", payload);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getJobStatusHistory = async (studentId, jobId) => {
  try {
    const res = await axiosInstance.get(`/job-status/history/${studentId}/${jobId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getStudentJobStatuses = async (studentId) => {
  try {
    const res = await axiosInstance.get(`/job-status/student/${studentId}`);
    return res.data;
  } catch (error) {
    return { success: false, data: [] };
  }
};

export const updateHrProfile = async (userId, updateData) => {
  try {
    const res = await axiosInstance.put(`/updatehr/${userId}`, updateData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const uploadHrPhoto = async (formData) => {
  try {
    const res = await axiosInstance.post("/uploadphoto", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const createCreditOrder = async (orderData) => {
  try {
    const res = await axiosInstance.post("/order", orderData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const sendCreditPaymentEmail = async (emailData) => {
  try {
    const res = await axiosInstance.post("/mail", emailData);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getHRCredits = async (userId) => {
  try {
    const res = await axiosInstance.get(`/gethr/${userId}`);
    return res.data.credits || 0;
  } catch (error) {
    throw error;
  }
};

export const getTotalCredits = async (userId) => {
  try {
    const res = await axiosInstance.get(`/totalcredits/${userId}`);
    return res.data.credits || 0;
  } catch (error) {
    throw error;
  }
};

/**
 * Fetch HR dashboard stats
 * @param {string} userId 
 */
export const getDashboardStats = async (userId) => {
  try {
    const response = await axiosInstance.get(`/dashboard/${userId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Fetch HR dashboard analytics
 * @param {string} userId 
 * @param {string} period 
 */
export const getDashboardAnalytics = async (userId, period) => {
  try {
    const response = await axiosInstance.get(`/dashboard/${userId}/analytics`, {
      params: { period }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get wishlisted students for HR
 * @param {Object} params - { hrId, page, limit }
 */
export const getWishlistedStudents = async (params) => {
  try {
    const response = await axiosInstance.get("/student-profile/wishlist", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Toggle student in HR wishlist
 * @param {string} hrId 
 * @param {string} studentId 
 */
export const toggleWishlist = async (hrId, studentId) => {
  try {
    const response = await axiosInstance.post("/student-profile/wishlist/toggle", {
      hrId,
      studentId,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Get candidate filter statistics
 * @param {string} hrId 
 */
export const getCandidateFilterStats = async (hrId) => {
  try {
    const response = await axiosInstance.get("/student-profile/filter-stats", {
      params: { hrId }
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

/**
 * Fetch detailed student information for HR
 * @param {string} studentId 
 */
export const getStudentDetailsForHr = async (studentId) => {
  try {
    const response = await axiosInstance.get(`/student-details/${studentId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};
